module.exports = __webpack_public_path__ + "static/media/education.0b42a2ed.svg";